import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...rest }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full min-h-[88px] px-3 py-2 rounded-md border bg-bg-surface text-fg-1 text-base font-sans',
          'transition-colors duration-fast ease-out resize-y',
          'placeholder:text-fg-3',
          'focus:outline-none focus:border-border-focus focus:ring-2 focus:ring-brand-500/20',
          invalid ? 'border-danger focus:ring-danger/20 focus:border-danger' : 'border-border',
          'disabled:bg-neutral-50 disabled:text-fg-disabled disabled:cursor-not-allowed',
          className,
        )}
        {...rest}
      />
    )
  },
)
Textarea.displayName = 'Textarea'
